'use strict';

// Dependencies
var _ = require('underscore');
var SolrSearchModel = require('bunsen/models/SolrSearchModel');
var Listings = require('bunsen/collections/inventory/Listings');
var endpoints = require('dibs-endpoints');
var ListingSearch;

/**
 * @class ListingSearch
 * @extends SolrSearchModel
 */

ListingSearch = module.exports = SolrSearchModel.extend({
    initialize: function (attrs, options) {
        attrs = attrs || {};
        options = options || {};
        options.collectionName = 'listings';
        options.collectionType = Listings;
        options.paramsMap = {
            bookmarked : 'qp.bookmarked',
            categoryCodeL2 : 'qp.categoryCodeL2',
            categoryCodeL3 : 'qp.categoryCodeL3',
            creator : 'qp.creatorUrlLabel',
            dealer : 'qp.sellerUrlLabel',
            locationId : 'qp.locationId',
            maxPrice : 'qp.maxPrice',
            marketplace : 'qp.marketplaceOnly',
            minPrice : 'qp.minPrice',
            notes : 'qp.notes',
            listingStatusGroup: 'qp.listingStatusGroup',
            pageStart : 'pageStart',
            periodId : 'qp.periodId',
            priceReduction: 'qp.priceReduction',
            publicationId : 'qp.publicationId',
            publicationRelation: 'qp.publicationRelation',
            publicationStatus: 'qp.publicationStatus',
            publicationType: 'qp.publicationType',
            itemReject: 'qp.itemReject',
            itemRepost: 'qp.itemRepost',
            searchTerm : 'qp.searchTerm',
            sellerPk: 'qp.sellerPk',
            shipping : 'qp.shippingUrlLabel',
            sort: 'qp.sort',
            vertical: 'qp.vertical',
            vettingStatus: 'qp.vettingStatus'
        };
        options.facetParamsMap = {
            bookmarked : 'bookmarked',
            categoryCodeL2 : 'item_cat_code_l2',
            categoryCodeL3 : 'item_cat_code_l3',
            creator : 'item_creator_facets',
            dealer : 'item_seller_facets',
            listingStatusGroup: 'listing_status_group',
            locationId : 'item_location_facets',
            marketplace: 'marketplace_only',
            notes : 'notes',
            periodId : 'item_attr_opt_facet_period',
            priceReduction : 'price_reduction_facets',
            itemReject: 'reject',
            itemRepost : 'repost',
            shipping : 'item_shipping_facets',
            vertical : 'item_vertical',
            vettingStatus: 'vetting_status'
        };
        options.queryTemplate = options.queryTemplate || 'publication.edit';
        options.baseParams = _.union(['queryTemplate', 'pageSize', 'pageStart', 'context'], options.baseParams);
        this.publicationId = options.publicationId;

        this.sellerPk = options.sellerPk;
        this.publicationType = options.publicationType;
        this.publicationStatus = options.publicationStatus;
        this.fields = options.fields;

        ListingSearch.__super__.initialize.call(this, attrs, options);
    },

    url : function () {
        return endpoints.listings();
    },

    /**
     * Get the max (i.e. last) page a number of items can be moved to.
     * @returns {Number}
     */
    getMaxMoveToPage : function () {
        var highestPage = Math.ceil(this.get('totalResults') / this.pageSize) - 1;
        return highestPage > 0 ? highestPage : 1;
    }
}, {
    FIELDS: {
        ITEM: 'ITEM',
        PUBLICATION: 'PUBLICATION',
        FULL: 'FULL',
        ITEM_LISTINGS_META_DATA : 'ITEM_LISTINGS_META_DATA'
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/ListingSearch.js
// module id = 2649
// module chunks = 64